const SvgNoSearchResult = (props) => (
  <svg
    width={153}
    height={179}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M76.5003 145.383C113.64 145.383 143.75 115.273 143.75 77.9999C143.75 40.7271 113.508 10.617 76.5003 10.617C39.3601 10.617 9.25 40.7271 9.25 77.9999C9.25 115.273 39.3601 145.383 76.5003 145.383Z"
      fill="var(--kula-dark-secondary-50, #EAEEF9)"
    />
    <g filter="url(#filter0_d_5473_154694)">
      <path
        d="M122.262 44.3082L123.323 129.731C123.323 132.649 120.936 134.904 118.017 134.904H34.7179C31.7997 134.904 29.4121 132.517 29.4121 129.731V19.9018C29.4121 16.9837 31.7997 14.7287 34.7179 14.7287H95.0707L122.262 44.3082Z"
        fill="url(#paint0_linear_5473_154694)"
      />
    </g>
    <path
      d="M70.0014 117.793H66.9506C66.2874 117.793 65.7568 117.13 65.7568 116.334C65.7568 115.538 66.2874 114.875 66.9506 114.875H70.0014C70.6646 114.875 71.1952 115.538 71.1952 116.334C71.1952 117.262 70.6646 117.793 70.0014 117.793Z"
      fill="var(--kula-dark-secondary-100, #CED7E2)"
    />
    <path
      d="M60.7161 117.793H42.9418C42.2786 117.793 41.748 117.13 41.748 116.334C41.748 115.538 42.2786 114.875 42.9418 114.875H60.7161C61.3793 114.875 61.9099 115.538 61.9099 116.334C61.9099 117.262 61.3793 117.793 60.7161 117.793Z"
      fill="var(--kula-dark-secondary-50, #D5DDEA)"
    />
    <path
      d="M83.3981 32.6359H43.4724C42.5439 32.6359 41.748 31.84 41.748 30.9115C41.748 29.983 42.5439 29.1871 43.4724 29.1871H83.3981C84.3266 29.1871 85.1225 29.983 85.1225 30.9115C85.1225 31.84 84.3266 32.6359 83.3981 32.6359Z"
      fill="var(--kula-dark-secondary-50, #D5DDEA)"
    />
    <path
      d="M58.8591 42.1861H43.4724C42.5439 42.1861 41.748 41.3902 41.748 40.4617C41.748 39.5332 42.5439 38.7373 43.4724 38.7373H58.7264C59.6549 38.7373 60.4508 39.5332 60.4508 40.4617C60.4508 41.3902 59.6549 42.1861 58.8591 42.1861Z"
      fill="var(--kula-dark-secondary-50, #D5DDEA)"
    />
    <path
      d="M95.0703 14.7287V38.3393C95.0703 41.6554 97.9885 44.3082 101.305 44.3082H122.262"
      fill="var(--kula-dark-secondary-50, #D5DDEA)"
    />
    <path
      d="M128.63 136.894C127.303 136.894 125.977 136.363 124.916 135.169L102.765 113.018L101.969 113.548C94.8061 118.854 86.4495 121.639 77.9604 121.639C67.7468 121.639 57.5333 117.527 49.9726 110.365C42.014 102.804 37.6367 92.5905 37.6367 81.4484C37.6367 59.2969 55.6762 41.2574 77.8277 41.2574C92.9491 41.2574 106.213 49.216 113.376 62.7457C120.406 76.1427 119.477 91.7946 110.856 104.396L110.325 105.192L132.609 127.476C134.864 129.731 134.333 131.986 133.935 133.18C132.874 135.302 130.752 136.894 128.63 136.894ZM77.8277 52.2668C61.6452 52.2668 48.6461 65.3985 48.6461 81.4484C48.6461 99.7532 63.6348 110.763 78.2256 110.763C87.1128 110.763 95.204 106.783 100.908 99.6206C107.938 90.8661 109.132 79.0608 104.224 68.8473C99.1833 58.6337 89.1024 52.2668 77.8277 52.2668Z"
      fill="var(--kula-dark-secondary-300, #989FB0)"
    />
    <path
      d="M65.2264 86.2237C66.9508 86.2237 68.4099 84.7646 68.4099 83.0403C68.4099 81.3159 66.9508 79.8568 65.2264 79.8568C63.502 79.8568 62.043 81.3159 62.043 83.0403C62.043 84.7646 63.502 86.2237 65.2264 86.2237Z"
      fill="var(--kula-dark-secondary-300, #989FB0)"
    />
    <path
      d="M89.6327 86.2237C91.357 86.2237 92.8161 84.7646 92.8161 83.0403C92.8161 81.3159 91.357 79.8568 89.6327 79.8568C87.9083 79.8568 86.4492 81.3159 86.4492 83.0403C86.4492 84.8973 87.9083 86.2237 89.6327 86.2237Z"
      fill="var(--kula-dark-secondary-300, #989FB0)"
    />
    <path
      d="M65.1016 72.5081L58.0986 76.2891L59.044 78.0399L66.0468 74.2587L65.1016 72.5081Z"
      fill="var(--kula-dark-secondary-300, #989FB0)"
    />
    <path
      d="M89.2 72.4579L88.2549 74.2088L95.2585 77.9892L96.2035 76.2383L89.2 72.4579Z"
      fill="var(--kula-dark-secondary-300, #989FB0)"
    />
    <path
      d="M77.4298 93.6518C79.481 93.6518 81.1439 92.4047 81.1439 90.8663C81.1439 89.3279 79.481 88.0807 77.4298 88.0807C75.3786 88.0807 73.7158 89.3279 73.7158 90.8663C73.7158 92.4047 75.3786 93.6518 77.4298 93.6518Z"
      fill="var(--kula-dark-secondary-300, #989FB0)"
    />
    <defs>
      <filter
        id="filter0_d_5473_154694"
        x={0.230532}
        y={0.13794}
        width={152.274}
        height={178.539}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={14.5908} />
        <feGaussianBlur stdDeviation={14.5908} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5473_154694"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5473_154694"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_5473_154694"
        x1={76.3374}
        y1={11.949}
        x2={76.3374}
        y2={136.199}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--kula-dark-secondary-200, #FDFEFF)" />
        <stop
          offset={0.9964}
          stopColor="var(--kula-dark-secondary-50, #ECF0F5)"
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgNoSearchResult;
